// React
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
// Components
import PrinterSettings from './PrinterSettings'
// Actions
import orderActions from '../../redux/actions/orders-actions'

const mapStateToProps = (
  { settingsReducer: { isAutoPrintActive: isActive } },
  { intl: { formatMessage } },
) => {
  const automaticPrinterTitle = formatMessage({
    id: 'settings.automaticPrinter',
  })
  const automaticPrinterDescription = formatMessage({
    id: 'settings.automaticPrinterDescription',
  })

  return {
    automaticPrinterTitle,
    automaticPrinterDescription,
    isActive,
  }
}
const mapDispatchToProps = {
  onChange: orderActions.setAutoPrint,
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PrinterSettings),
)
